<template>
  <div id="unauthenticated-layout">
    <header id="basic-header">
      <b-img id="basic-logo" width="300" height="86" fluid center src="/img/AAR_Logo.svg" alt="AAR logo" />
    </header>
    <main id="basic-main">
      <div id="basic-content">
        <flash-alert />
        <slot />
      </div>
    </main>
    <footer id="basic-footer">
      <div class="text-center mt-2">
        <copyright-link />
      </div>
    </footer>
    <privacy-policy-modal />
  </div>
</template>

<script>
import FlashAlert from "../components/alerts/FlashAlert";
import BottomNavbar from "../components/navbars/BottomNavbar";
import CopyrightLink from "../components/links/CopyrightLink";
import PrivacyPolicyModal from "../components/modals/PrivacyPolicyModal";

export default {
  components: {
    BottomNavbar,
    CopyrightLink,
    FlashAlert,
    PrivacyPolicyModal,
  },
  created: function () {
    document.body.style.backgroundColor = "#f5f5f5";
  },
};
</script>
